import React, { useState } from "react";
import { Container, Row, Col, Form, Button, InputGroup } from "react-bootstrap";
import "./register.css";
import recalllogo from "../assets/images/recalllogo.png";
import axios from "axios";
import { BASE_URL, ERROR, ROUTES } from "../assets/constant";
import Messages from "../components/message";
import { useNavigate } from "react-router-dom";
import { Eye, EyeSlashFill } from "react-bootstrap-icons";
import { CustomModal } from "../components/custom-modal";

export function ResetPassword() {
  const [form, setForm] = useState({});
  const [alertType, setAlertType] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${BASE_URL}/users/reset-password`, {
        password: form.password,
        token: window.location.pathname.split("/")[3]
      });
      setShowModal(true);
    } catch (error) {
      setAlertType(ERROR);
      setAlertMessage(error?.response?.data?.message || "Something went wrong");
      setShowAlert(true);
    }
  };

  const inserData = (key, value) => {
    setForm({ ...form, [key]: value });
  };
  const clickHandler = ({ isConfirmPass = false }) => {
    const passwordInput = document.querySelector('input[name="password"]');
    const confirmPassInput = document.querySelector(
      'input[name="confirmpassword"]'
    );

    if (confirmPassInput && isConfirmPass) {
      confirmPassInput.type = showConfirmPass ? "password" : "text";
      setShowConfirmPass((prev) => !prev);
    }

    if (passwordInput && !isConfirmPass) {
      passwordInput.type = showPass ? "password" : "text";
      setShowPass((prev) => !prev);
    }
  };
  return (
    <div className="register-page">
      <Container className="d-flex justify-content-center align-items-center vh-100">
        <Row className="register-container">
          {/* Image Section */}
          <Col md={6} className="register-image-section"></Col>

          {showModal && (
            <CustomModal
              isOpen={showModal}
              heading="Success"
              text="Your password has been reset successfully"
              closeModal={() => navigate(ROUTES.LOGIN)}
              onClick={() => navigate(ROUTES.LOGIN)}
              btnName={"OK"}
            />
          )}

          {/* Form Section */}
          <Col md={6} className="register-form-section">
            <div className="form-header">
              <img src={recalllogo} alt="Recall Logo" />
            </div>

            <div className="scrollable-form">
              <Form className="register-form" onSubmit={handleSubmit}>
                {showAlert && (
                  <Messages
                    type={alertType}
                    message={alertMessage}
                    onClose={() => setShowAlert(false)}
                  />
                )}
                <Form.Group controlId="formBasicPassword" className="mb-3">
                  <Form.Label>Password</Form.Label>
                  <InputGroup className="mb-3">
                    <Form.Control
                      type="password"
                      name="password"
                      placeholder="Password"
                      minLength={8}
                      value={form["password"]}
                      onChange={(e) => inserData("password", e.target.value)}
                      required
                      title="Password must be 8 characters long"
                    />
                    <InputGroup.Text onClick={clickHandler}>
                      {showPass ? <EyeSlashFill /> : <Eye />}
                    </InputGroup.Text>
                  </InputGroup>
                </Form.Group>
                <Form.Group controlId="formBasicPassword" className="mb-3">
                  <Form.Label>Confirm Password</Form.Label>
                  <InputGroup className="mb-3">
                    <Form.Control
                      type="password"
                      name="confirmpassword"
                      placeholder="Confirm password"
                      minLength={8}
                      value={form["confirmpassword"]}
                      onChange={(e) =>
                        inserData("confirmpassword", e.target.value)
                      }
                      title="Must be same as password"
                      required
                    />
                    <InputGroup.Text
                      onClick={() => clickHandler({ isConfirmPass: true })}>
                      {showConfirmPass ? <EyeSlashFill /> : <Eye />}
                    </InputGroup.Text>
                  </InputGroup>
                  <Form.Label className="text-danger">
                    {form["password"] !== form["confirmpassword"] &&
                    form["confirmpassword"]
                      ? "Password does not match"
                      : null}
                  </Form.Label>
                </Form.Group>
                <Button
                  variant="primary"
                  type="submit"
                  className={`recallButton w-100`}
                  disabled={form["password"] !== form["confirmpassword"]}>
                  Submit
                </Button>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
